module.exports = __webpack_public_path__ + "static/media/withdrawal@2x.83118b9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/withdrawal@2x.png
// module id = 896
// module chunks = 0